
import { Component, Vue } from "vue-property-decorator";
import { Logger } from "@/utils/Logger";

@Component
export default class Header extends Vue {
  drawer: boolean = true;

  get isLoggedIn(): boolean {
    return this.$store.getters.isLoggedIn();
  }

  get isAdmin(): boolean {
    return this.$store.getters.isAdmin();
  }

  get loggedInUsername(): string {
    return this.$store.getters.userEtab();
  }

  allerAModifierMotDePasse(): void {
    this.$router.push({ name: "Password" }).catch(err => {
      Logger.error(err);
    });
  }

  allerAModifierProfil(): void {
    this.$router.push({ name: "Profil" }).catch(err => {
      Logger.error(err);
    });
  }

  saveTheme(): void {
    this.$store.dispatch("changeTheme").catch(err => {
      Logger.error(err);
    });
  }

  seDeconnecter(): void {
    this.$store.dispatch("logout").catch(err => {
      Logger.error(err);
    });
  }
}
